exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?minimize!ag-grid-community/styles/ag-grid.css"), "");
exports.i(require("-!../../../../../node_modules/css-loader/index.js?minimize!ag-grid-community/styles/ag-theme-material.css"), "");

// module
exports.push([module.id, ".ag-theme-material{font-family:Poppins,sans-serif!important}.header-actual .ag-header-cell-label{color:#d04e8c!important;font-weight:600}.header-deseada .ag-header-cell-label{color:#4a90e2!important;font-weight:600}.ag-header-cell-label{font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ee68969","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/sections/results/ResultsTable.vue
// module id = 1897
// module chunks = 2